import template from './dashboardScreen.html';
import controller from './dashboardScreen.controller';

let component = {
  restrict: 'E',
  template,
  controller,
  controllerAs: 'vm',
  bindings: {
    staffUser: '<',
    isOnline: '<'
  },
};

export default component;
